
import axios from 'axios'

export function generateNet(config, useInterceptors) {
    const netApi = axios.create(config)
    useInterceptors(netApi)
    return netApi
}
